var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3,10.4c-0.4,0-0.7,0-1.1,0.1L16.4,6c-0.1-0.1,0-0.2,0-0.3c0-0.1,0.1-0.1,0.3-0.1h2.6c0.4,0,0.7-0.3,0.7-0.7 c0-0.4-0.3-0.7-0.7-0.7h-2.6c-0.5,0-1,0.3-1.4,0.7C15,5.4,15,6,15.2,6.5l0.4,1H9.5L9.1,6.6h0.7c0.4,0,0.7-0.3,0.7-0.7 c0-0.4-0.3-0.7-0.7-0.7H6.7c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7h1L8.3,8l-1.7,2.7c-0.6-0.3-1.2-0.4-1.9-0.4 c-2.6,0-4.7,2.1-4.7,4.7c0,2.6,2.1,4.7,4.7,4.7c2.4,0,4.3-1.8,4.7-4h1.5c0.8,0,1.5-0.4,1.9-1l3.6-5.2L17,11 c-1.4,0.8-2.4,2.3-2.4,4.1c0,2.6,2.1,4.7,4.7,4.7c2.6,0,4.7-2.1,4.7-4.7C24,12.5,21.9,10.4,19.3,10.4L19.3,10.4z M8.9,9.6l1.9,4.9 H9.4c-0.2-1.2-0.8-2.2-1.7-3L8.9,9.6z M4.7,18c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9c1.4,0,2.6,1,2.8,2.3H4.7 c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7h2.8C7.3,17,6.1,18,4.7,18z M11.9,13.7L10,8.8h5.3L11.9,13.7L11.9,13.7z M19.3,18 c-1.6,0-2.9-1.3-2.9-2.9c0-1,0.5-1.9,1.3-2.4l1,2.6c0.1,0.3,0.3,0.4,0.6,0.4c0.1,0,0.2,0,0.2,0c0.3-0.1,0.5-0.5,0.4-0.9l-1-2.7 c0.1,0,0.3,0,0.4,0c1.6,0,2.9,1.3,2.9,2.9S20.9,18,19.3,18z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.d46823ab9d5a49217258607bdb661aa4.svg";
export { ForwardRef as ReactComponent };